import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parseString } from 'xml2js';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import ExerciseInterface from './ExerciseInterface';
import InteractionInterface from '../services/InteractionInterface';
import * as actions from '../actions';

class App extends Component {
	constructor(props) {
		super(props);
		this.version = null;
	}

	componentDidMount() {
		const { loaderAppElement, loaderExternalInterface, setInteractionInterface, setBasePath } = this.props;
		new window.loader.exercises.common.ConfigurationDelegateCallback(this.dataLoaded.bind(this)).load(`${this.props.base}aahiddenanswer.xml`);
		this.setupTestHandlers();
		setBasePath(this.props.base);
		setInteractionInterface(
			new InteractionInterface(
				loaderAppElement,
				loaderExternalInterface,
				this.props.store
			)
		);
	}

	componentWillReceiveProps(nextProps) {
		const { exContainer, testMode } = nextProps;

		if (testMode) {
			window.nl_loader.getTestAdmin().hideButtons(exContainer);
		}
	}

	setupTestHandlers() {
		const { testMode, loaderAppElement, setTestSent, restartExercise, setTestMode, setExContainer } = this.props;

		if (testMode) {
			const exContainer = window.nl_loader.getExContainerByChild(loaderAppElement);
			setTestMode(testMode);
			setExContainer(exContainer);

			switch (testMode) {
				case 'exam': {
					window.nl_loader.getTestAdmin().setCheckAnswersHandler(exContainer, setTestSent);
					window.nl_loader.getTestAdmin().setExerciseFinishedHandler(exContainer, () => {
						const { items, correctAnswers } = this.props.store.getState().exercise;
						return items.length === correctAnswers.filter(e => e !== undefined).length;
					});
					if (window.NL_CONFIG.debugTest) {
						window.nl_loader.getTestAdmin().setRestartHandler(exContainer, restartExercise);
					}
					break;
				}
				default:
			}
		}
	}

	dataLoaded(xml, res) {
		const {
			onDataLoaded,
			setVersion,
			setAutoNum,
			setRandomItems,
			setItemsToShow,
			setItems,
			processItems,
			interaction,
			loaderExternalInterface,
			setAudioPrefix,
			setAudioEnabled,
			setPhoneme,
		} = this.props;

		parseString(res.responseText, { explicitCharkey: true }, (err, result) => {
			if (err) window.alert(`parseString error: ${err.message}`);

			onDataLoaded(result);

			const xmlNode = result.AaPronunciation || result.AaAnalyseSounds || result.AaHiddenAnswer || {};
			const attrs = xmlNode.$ || {};
			setVersion(attrs.version ? attrs.version : 1);
			setAutoNum(attrs.autoNum === 'true');
			setItemsToShow(attrs.itemsToShow);
			setRandomItems(attrs.randomItems === 'true');
			setAudioPrefix(attrs.audioPrefix || '');
			setAudioEnabled(attrs.audio !== 'false');
			if (attrs.phoneme === undefined) {
				setPhoneme(null);
			} else {
				setPhoneme(attrs.phoneme.length ? attrs.phoneme.split(',') : []);
			}

			setItems(xmlNode.item);

			if (interaction) {
				interaction.recover();
			}

			processItems();

			loaderExternalInterface.appLoaded = true;
		});
	}

	render() {
		const { exerciseReady, items } = this.props;

		if (!exerciseReady) return <div />;

		return <ExerciseInterface items={items} />;
	}
}

App.propTypes = {
	items: PropTypes.array,
	processItems: PropTypes.func.isRequired,
	loaderAppElement: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
	loaderExternalInterface: PropTypes.object.isRequired,
	base: PropTypes.string.isRequired,
	setInteractionInterface: PropTypes.func.isRequired,
	setVersion: PropTypes.func.isRequired,
	setAutoNum: PropTypes.func.isRequired,
	setItems: PropTypes.func.isRequired,
	setTestMode: PropTypes.func.isRequired,
	setExContainer: PropTypes.func.isRequired,
	setTestSent: PropTypes.func.isRequired,
	restartExercise: PropTypes.func.isRequired,
	setRandomItems: PropTypes.func.isRequired,
	setItemsToShow: PropTypes.func.isRequired,
	setBasePath: PropTypes.func.isRequired,
	interaction: PropTypes.object,
	testMode: PropTypes.string,
	exContainer: PropTypes.object,
	exerciseReady: PropTypes.bool.isRequired,
	onDataLoaded: PropTypes.func,
	setAudioPrefix: PropTypes.func.isRequired,
	setAudioEnabled: PropTypes.func.isRequired,
	setPhoneme: PropTypes.func.isRequired,
	store: PropTypes.object.isRequired
};

App.defaultProps = {
	items: [],
	interaction: null,
	testMode: undefined,
	exContainer: undefined,
	onDataLoaded: () => { },
};

const mapStateToProps = ({ exercise: { items, exerciseReady }, loader }) => ({
	items,
	exerciseReady,
	interaction: loader.interaction,
	exContainer: loader.exContainer
});

export default compose(
	connect(mapStateToProps, actions)
)(App);
